/**
 * @generated SignedSource<<12f5653ce8b90646708ce1a81e11d25d>>
 * @relayHash d0a4e0f0d940268315c42b1298fd995e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4a3192b3c21002961787dd23c9769033e3e25dc56663815f63c810152f5b9b69

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSpaPageContainerQuery$variables = {
  cloudId: string;
};
export type JiraSpaPageContainerQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"JiraSpaPageContainer">;
};
export type JiraSpaPageContainerQuery = {
  response: JiraSpaPageContainerQuery$data;
  variables: JiraSpaPageContainerQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcbannerannouncementviasparelayprovider": bannerAnnouncementViaSpa_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcbannerannouncementviasparelayprovider: {
    readonly get: () => boolean;
  };
});

import bannerAnnouncementViaSpa_provider from '@atlassian/jira-relay-provider/src/banner-announcement-via-spa.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "name": "JiraSpaPageContainerQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "JiraSpaPageContainer"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbannerannouncementviasparelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "JiraSpaPageContainerQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcbannerannouncementviasparelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                  }
                ],
                "concreteType": "JiraAnnouncementBanner",
                "kind": "LinkedField",
                "name": "announcementBanner",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isDismissible"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "visibility"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "__typename"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4a3192b3c21002961787dd23c9769033e3e25dc56663815f63c810152f5b9b69",
    "metadata": {},
    "name": "JiraSpaPageContainerQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcbannerannouncementviasparelayprovider": bannerAnnouncementViaSpa_provider
    }
  }
};
})();

(node as any).hash = "798e2c45197387a6c034abffdd1ad8e1";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
